<template>
  <div id="RiskWarningDialog">
    <el-dialog title="设置" :visible.sync="dialogVisible" width="500px" :before-close="changeDialogVisible">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="下单后弹出对话框">
          <el-switch v-model="form.delivery"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button class="el-cancel-btn" @click="changeDialogVisible">取消</el-button> -->
        <el-button type="primary" class="el-confirm-btn" :disabled="isClicked" @click="closePositionConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global*/
import {
  mapGetters
} from 'vuex'
export default {
  name: 'Trade',
  props: ['dialogVisible'],
  data() {
    return {
      isClicked: false,
      form: {
        delivery: false
      },
      rules: {

      }
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const obj = JSON.parse(localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`))
      if (obj === true || obj === 'true') {
        this.form = {
          delivery: true
        }
      } else {
        this.form = {
          delivery: false
        }
      }
    },
    // 关闭前操作
    changeDialogVisible() {
      this.$emit('closeSettingDialog')
    },
    closePositionConfirm() {
      localStorage.setItem(`settingDea${this.sessionInfoGetter.tel}`, this.form.delivery)
      this.$emit('closeSettingDialog')
    }
  }
}
</script>
<style scoped lang="scss">

  li {
    position: relative;
    margin-bottom: 10px;
  }
  li:nth-child(1) span:nth-child(2n) {
    margin-right: 28%;
  }
  li:nth-child(2) div {
    float: left;
  }
  input[type="text"] {
    display: block;
    margin: 5px 0 0;
    height: 34px;
    border: 1px solid rgba(78, 89, 133, 1);
    border-radius: 5px;
    background: transparent;
  }
  li:nth-child(4) input[type="text"] {
    width: 73%;
  }
  input[type="text"]+span,
  li:nth-child(4) input[type="text"]+span+p {
    position: absolute;
    top: 35px;
    color: rgba(153, 204, 255, 0.4);
  }
  li:first-child input[type="text"]+span {
    right: 22%;
  }
  li:nth-child(4) input[type="text"]+span {
    right: 47%;
  }
  li:nth-child(4) input[type="text"]+span+p {
    right: 24%;
    color: white;
  }
  #RiskWarningDialog /deep/ .el-input.is-disabled .el-input__inner{
    background-color: transparent;
  }
  #RiskWarningDialog /deep/ .el-time-spinner__list .active{
    background: transparent;
  }
  #RiskWarningDialog /deep/ .el-date-editor .el-range-input{
    color: #C0C4CC;
  }
</style>
<style>
  #RiskWarningDialog .el-form-item__label {
    color: #fff;
  }
  #RiskWarningDialog .el-dialog {
    border-radius: 10px;
  }
   /* #RiskWarningDialog li{
     margin-right: 18%;
   } */
  #RiskWarningDialog .el-dialog__footer {
    padding:  20px;
  }
  #RiskWarningDialog .el-dialog__footer::after {
    content: "";
    display: block;
    clear: both;
  }
  #RiskWarningDialog .el-cancel-btn span,
  #RiskWarningDialog .el-confirm-btn span {
    color: #fff !important;
  }
  #RiskWarningDialog .el-confirm-btn,
  #RiskWarningDialog .el-cancel-btn {
    float: right;
    margin-right: 14%;
    width: 135px;
    height: 36px;
    line-height: 0px;
    border: 0;
    background-color: rgba(75, 85, 127, 1) !important;
  }
  #RiskWarningDialog .el-confirm-btn {
    background-color: rgba(122, 152, 248, 1) !important;
  }

</style>
